export default function responseFetchNotifications(response: any, api: any, arg: any) {
    console.log('notifications response', response);
    // Only return the data part, don't dispatch to Redux
    return response.data;
}
